module.exports = __webpack_public_path__ + "img/chatConnecIcon.9ab219e5.svg";